import Vue from 'vue'
import VueRouter from 'vue-router'
import MyDocument from '../views/MyDocument.vue'
import EndDocument from '../views/tramites/EndDocument.vue'
import Document from '../views/tramites/Document.vue'
import DocumentList from '../views/tramites/DocumentList.vue'
import SelectDocument from '../views/tramites/SelectDocument.vue'
import PaymentMessage from '../views/tramites/PaymentMessage.vue'
import StatusDocument from '../views/tramites/StatusDocument.vue'
import DocumentMenu from '../views/tramites/DocumentMenu.vue'
import NewDocument from '../views/NewDocument.vue'
import Boleta from '../views/Boleta.vue'
import Help from '../views/Help.vue'
import Ticket from '../views/tramites/Ticket.vue'
import PaymentList from '../views/PaymentList.vue'
import Login from '../components/authentication/Login.vue'
import Signup from '../components/authentication/SignUp.vue'
import ChangePasswordMessage from '../components/authentication/ChangePasswordMessage.vue'
import SignUpMessage from '../components/authentication/SignUpMessage.vue'
import SignupPassport from '../components/authentication/SignUpPassport.vue'
import ForgotPassword from '../components/authentication/ForgotPassword.vue'
import ConfirmForgotPassword from '../components/authentication/ConfirmForgotPassword.vue'
import ConfirmSignUp from '../components/authentication/ConfirmSignUp.vue'

import store from '@/store/index.js'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup
    },
    {
      path: '/signuppassport',
      name: 'SignupPassport',
      component: SignupPassport
    },
    {
      path: '/confirmsignup',
      name: 'ConfirmSignUp',
      component: ConfirmSignUp
    },
    {
      path: '/signupmessage',
      name: 'SignUpMessage',
      component: SignUpMessage
    },
    {
      path: '/changepasswordmessage',
      name: 'ChangePasswordMessage',
      component: ChangePasswordMessage
    },
    {
      path: '/forgotpassword',
      name: 'ForgotPassword',
      component: ForgotPassword
    },
    {
      path: '/confirmforgotpassword',
      name: 'ConfirmForgotPassword',
      component: ConfirmForgotPassword
    },
    {
      path: '/paymentlist',
      name: 'PaymentList',
      component: PaymentList,
      meta: { requiresAuth: true }
    },
    {
      path: '/mydocument',
      name: 'MyDocument',
      component: MyDocument,
      children: [
        {
          path: ':documentlist',
          name: 'DocumentList',
          component: DocumentList
        },
        {
          path: ':enddocument/:id',
          name: 'EndDocument',
          component: EndDocument
        }
      ],
      meta: { requiresAuth: true }
    },
    {
      path: '/newdocument',
      name: 'NewDocument',
      component: NewDocument,
      children: [
        {
          path: ':selectdocument',
          name: 'SelectDocument',
          component: SelectDocument
        },
        {
          path: ':document/:id',
          name: 'Document',
          component: Document
        }
      ],
      meta: { requiresAuth: true }
    },
    {
      path: '/ticket/:id',
      name: 'Ticket',
      component: Ticket,
      meta: { requiresAuth: true }
    },
    {
      path: '/boleta/:id',
      name: 'Boleta',
      component: Boleta,
      meta: { requiresAuth: true }
    },
    {
      path: '/documentmenu',
      name: 'DocumentMenu',
      component: DocumentMenu,
      meta: { requiresAuth: false }
    },
    {
      path: '/statusdocument/:id',
      name: 'StatusDocument',
      component: StatusDocument,
      meta: { requiresAuth: true }
    },
    {
      path: '/paymentmessage/:id',
      name: 'PaymentMessage',
      component: PaymentMessage,
      meta: { requiresAuth: true }
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
      meta: { requiresAuth: true }
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(route => route.meta.requiresAuth)) {
    if (store.state.authenticated === false) {
      next({ name: 'Login', query: { to: to.fullPath } })
    } else {
      next()
    }
  } else {
    next()
  }
})

router.afterEach((to, from) => {
  window.gtag('config', 'UA-169797799', {
    page_path: '/' + (to.path || '')
  })
})

export default router
